<template>
    <div :style="mainContentViewHeight" class="main_center" v-loading.lock="fullscreenLoading">
        <div class="top-content busWinessLeft" style="z-index:3;">
            <!-- ruleForm.endStatus 1:已办结 2：未办结 3：已失效 4：已终止 -->
            <div class="left-navbar">
                <el-button @click="backRouter">返回</el-button>
                <el-button
                    type="primary"
                    v-debounce="[isAgree, 'click', 300, 'argee']"
                    v-if="!(ruleForm.endStatus==1||ruleForm.endStatus==3)&&ruleForm.historyid==-1&&hasBtnPermission('online_complaints_btn_agree')"
                >同意</el-button>
                <el-button class="noAgreeBtn" v-debounce="[isAgree, 'click', 300, 'noAgree']" v-if="hasBtnPermission('online_complaints_btn_agree')&&ruleForm.historyid==-1">不同意</el-button>
            </div>
        </div>
        <div class="right-content busWinessRight">
            <!-- ruleForm.historyid :-1 待审核 0通过 1不通过   -->
            <div class="statusImg">
                <img src="../../../../../assets/images/agree.png" v-if="ruleForm.historyid==0" />
                <img src="../../../../../assets/images/noAgree.png" v-if="ruleForm.historyid==1" />
                <img
                    src="../../../../../assets/images/waitHandle.png"
                    v-if="ruleForm.historyid==-1"
                />
            </div>
            <el-form :model="ruleForm" label-width="220px" ref="ruleForm" >
                <el-card class="box-card">
                    <div class="clearfix" slot="header">
                        <span>投诉撤回申请</span>
                    </div>
                    <el-row>
                        <el-col :span="24">
                           
                            <el-form-item
                                prop="complaintCode"
                                size="small"
                            >
                            <span slot="label">
                                <span style="color:red;">*</span> 
                                投诉编号：
                            </span>
                            {{ruleForm.complaintCode}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                prop="quashReason"
                                size="small"
                            >
                            <span slot="label">
                                <span style="color:red;">*</span> 
                                撤回原因：
                            </span>
                            {{ruleForm.quashReason}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item
                                prop="quashUser"
                                size="small"
                            >
                            <span slot="label">
                                <span style="color:red;">*</span> 
                                撤回申请人：
                            </span>
                            {{ruleForm.quashUser}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item
                                prop="linkPhone"
                                size="small"
                            >
                            <span slot="label">
                                <span style="color:red;">*</span> 
                                申请人联系方式：
                            </span>
                            {{ruleForm.linkPhone}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item
                                label="申请人时间："
                                prop="createTime"
                                size="small"
                            >{{ruleForm.createTime}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col
                            :span="24"
                            class="affixDown"
                            v-for="(item,index) in ruleForm.attachments"
                            :key="index"
                        >
                            <affix-doc
                                :isStar="true"
                                :item.sync="item"
                                :name="item.fileTypeName"
                                labelWidth="220px"
                            />
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card">
                    <div class="clearfix" slot="header">
                        <span>相关投诉信息</span>
                    </div>
                    <div>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item
                                    label="投诉企业名称："
                                    prop="appelleeEntName"
                                    size="small"
                                >{{ruleForm.appelleeEntName}}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item
                                    label="投诉人："
                                    prop="complainter"
                                    size="small"
                                >{{ruleForm.complainter}}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item
                                    label="投诉标段名称："
                                    prop="bidSectionName"
                                    size="small"
                                >{{ruleForm.bidSectionName}}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item
                                    label="投诉标段编号："
                                    prop="bidSectionCode"
                                    size="small"
                                >{{ruleForm.bidSectionCode}}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item
                                    label="投诉提交时间："
                                    prop="complaintTime"
                                    size="small"
                                >{{ruleForm.complaintTime}}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item size="small">
                                    <el-button class="arrowRightBtn" @click="viewDetailInfo">
                                        查看详细投诉信息
                                        <i class="el-icon-d-arrow-right"></i>
                                    </el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div class="clearfix" slot="header">
                        <span>工作流</span>
                    </div>
                    <div>
                        <el-table
                            :data="tableData"
                            border
                            stripe
                            style="width: 100%"
                            v-loading.lock="tableLoading"
                        >
                            <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                            <el-table-column prop="taskName" label="任务名称" width="250"></el-table-column>
                            <el-table-column prop="userName" label="执行人" width="300"></el-table-column>
                            <el-table-column
                                prop="excuteDate"
                                label="执行时间"
                                width="180"
                                align="center"
                            ></el-table-column>
                            <el-table-column prop="auditMsg" label="意见"></el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </el-form>
        </div>
        <el-dialog title="意见" :visible.sync="dialogVisible" width="30%">
            <div class="dialogBox">
                <span>处理意见：</span>
                <el-input
                    type="textarea"
                    maxlength="100"
                    show-word-limit
                    v-model="ruleForm.variables.opinion"
                    :rows="4"
                ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSure" style="margin-bottom:20px;">确 定</el-button>
                <el-button @click="dialogVisible=false" class="backBtn">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getSingleComplaintQuash, //获取单条记录
    getComplaintQuashProcessSubmit,
    getWorkflowgetInfo,
    getByComplaintId
} from "@/server/complaint";
import affixMsg from "@/components/affixMsg";
import affixDoc from "@/components/affixDoc";
export default {
    props: ["mainContentViewHeight"],
    data() {
        return {
            fullscreenLoading: false,
            tableLoading: false,
            dialogVisible: false,
            ruleForm: {variables:{}},
            tableData: [],
            id: "",
        };
    },
    components: {
        affixMsg,
        affixDoc
    },
    mounted() {
        this.id = this.$route.query.id || "";
        let type = this.$route.query.type || "";
        // 其他 处理列表页跳转过来的异常处理数据
        if (this.id && type == "exception") {
            this.getComplaintById();
        } else if (this.id) {
            // 获取详情
            this.getSingleComplaintData();
        }
    },
    methods: {
        getComplaintById() {
            this.fullscreenLoading = true;
            getByComplaintId(this.id)
                .then(res => {
                    if (res.data.code == 1) {
                        this.ruleForm = res.data.data;
                        this.fullscreenLoading = false;
                        if (this.ruleForm.processinstanceid) {
                            this.getWorkflowgetInfoFunc();
                        }
                    }
                })
                .finally(() => {
                    this.fullscreenLoading = false;
                });
        },
        getSingleComplaintData() {
            this.fullscreenLoading = true;
            getSingleComplaintQuash(this.id).then(res => {
                if (res.data.code == 1) {
                    this.ruleForm = res.data.data;
                    this.fullscreenLoading = false;
                    if (this.ruleForm.processinstanceid) {
                        this.getWorkflowgetInfoFunc();
                    }
                }
            });
        },
        getWorkflowgetInfoFunc() {
            this.tableLoading = true;
            getWorkflowgetInfo(this.ruleForm.processinstanceid).then(res => {
                if (res.data.code == 1) {
                    console.log(res);
                    this.tableData = res.data.data.auditHistorys;
                    this.tableLoading = false;
                }
            });
        },
        backRouter() {
            //返回
            this.ruleForm = {};
            this.tabsCloseCurrent();
            this.$router.push({
                name: "online_complaints_list",
                query: {
                       tabActived:'exception'
                        },
            });
           
        },
        viewDetailInfo() {
            removeTabHandle("offline_complaints");
            this.$router.push({
                name: "offline_complaints",
                query: {
                    id: this.ruleForm.complaintId,
                    code: this.ruleForm.complaintCode,
                    tabActived:'exception'
                }
            });
        },
        isAgree(flag) {
            if (flag == "argee") {
                this.$set(this.ruleForm.variables, "opinion", "同意");
                this.$set(this.ruleForm.variables, "commit", true);// 流程参数
            } else {
                this.$set(this.ruleForm.variables, "opinion", "不同意");
                this.$set(this.ruleForm.variables, "commit", false);
            }
            this.dialogVisible = true;
        },
        handleSure() {
            this.fullscreenLoading = true;
            getComplaintQuashProcessSubmit(this.ruleForm)
                .then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        this.dialogVisible = false;
                        this.fullscreenLoading = false;
                        this.getSingleComplaintData();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .finally(() => {
                    this.fullscreenLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.main_center {
    .arrowRightBtn {
        width: 200px;
        border: 1px solid #1890ff;
        color: #1890ff;
    }
    .noAgreeBtn {
        border: 1px solid #1890ff;
        color: #1890ff;
    }
    .statusImg {
        position: absolute;
        right: 20px;
        top: 20px;
    }
}
</style>